import { ThoughtBubbleIcon } from './ThoughtBubbleIcon';

/**
 * author: Austin Andrews
 * id 46ACA864-4B1C-4DBD-94FB-7A0D6B9A500E
 * name thought-bubble
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thought-bubble.svg
 * tags
 */
export const ComicBubbleIcon = ThoughtBubbleIcon;
export default ComicBubbleIcon